import { TROUBLESHOOTING_ANSWERS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/troubleshooting_answer_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['troubleshootingAnswerIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
